import { forwardRef, type Ref, type SVGProps } from "react";
const IconCopyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m6.975 27.941 3 .013V30H7.034a2.06 2.06 0 0 1-2.059-2.059V25h2.012Zm9 .038V30h-4v-2.038zm4.941.021.059-2h2v1.941A2.06 2.06 0 0 1 20.916 30h-2.941v-2.012ZM4.975 12.059A2.06 2.06 0 0 1 7.034 10h1.941v2H7.034l-.013 3H4.975ZM7.013 17l-.017 6H4.975v-6zm6.071-15h13.782a2.11 2.11 0 0 1 2.109 2.109v17.783A2.11 2.11 0 0 1 26.867 24H13.084a2.11 2.11 0 0 1-2.108-2.108V4.109A2.11 2.11 0 0 1 13.084 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCopyFilledSVG);
ForwardRef.displayName = "IconCopyFilled";
export { ForwardRef as IconCopyFilled };
